export const SET_DEALER_DATA = 'SET_DEALER_DATA';
export const RESET_DEALER_DATA = 'RESET_DEALER_DATA';

export function setDealerData(dealerData) {
  return {
    type: SET_DEALER_DATA,
    payload: dealerData
  };
}

export function resetDealerData() {
  return {
    type: RESET_DEALER_DATA
  };
}

const initialState = {
  salesPerson: { salesPersonId: '91657' }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_DEALER_DATA:
      if (action.payload.salesPersonId) {
        return {
          ...action.payload
        };
      }
      return {
        salesPerson: { salesPersonId: state.salesPerson.salesPersonId },
        ...action.payload
      };
    case RESET_DEALER_DATA:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
